// ESG
// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import ESGRouter from '@/features/energyxplorer/components/esg/ESGRouter';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/esg',
)({
  component: ESGRouter,
  staticData: { crumb: 'energyxplorer:app_bar.esg' },
});
